function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
export var ChevronRight = function(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        width: "13",
        height: "22",
        viewBox: "0 0 13 22",
        fill: "none",
        stroke: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M2 1L12 11L2 21",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};

//# sourceMappingURL=ChevronRight.js.map